import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import configStore from './stores'
import "./assets/scss/material-kit-react.css?v=1.3.0"

ReactDOM.render( 
   
    <Provider store={configStore()}>
        <App />
    </Provider>

, document.getElementById('root'));

serviceWorker.unregister();
